import { Component, Input } from '@angular/core';
import { IHistoryRecord } from './../../../../shared/modals/history-all/history-all-helpers.service';

@Component({
  selector: 'history-card',
  template: require('./history-card.component.html'),
})
export class HistoryCard {
  @Input() historyRecord: IHistoryRecord;
  @Input() open: boolean;

  constructor() {
    //
  }
}
